// frontend/src/components/mcbim/DisciplinesMenuContent.tsx
import React from "react";
import { Checkbox, Box, Text, Group } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectHttpUniqDisciplinesOnBuildingStory } from "../../designSelector";
import { setDisciplineToDisplayInRedux } from "../../designSlice";
import { DisciplineCode, DISCIPLINES } from "../../../constants";

// Norsk (Bokmål): Kun innholdet i menyen (wrapperen eier selve Menu/knapp).
export const DisciplinesMenuContent: React.FC = () => {
  const dispatch = useAppDispatch();

  const uniqDisciplines = useAppSelector(selectHttpUniqDisciplinesOnBuildingStory); // string[]
  const disciplinesToDisplay = useAppSelector((s) => s.design.disciplinesToDisplay ?? {});

  return (
    <>
      <Box px="sm" py={6}>
        <Text size="xs" fw={600} c="dimmed">
          Vis / skjul disipliner
        </Text>
      </Box>

      <Box px="xs" pb="xs">
        {uniqDisciplines.map((d) => {
          const meta = (DISCIPLINES as Record<string, any>)[d] as
            | (typeof DISCIPLINES)[DisciplineCode]
            | undefined;

          const label = meta?.label ?? d; // vis label hvis finnes, ellers behold verdi
          const color = meta?.color ?? "#BDBDBD"; // fallback-grå

          return (
            <Box key={d} py={4} onMouseDown={(e) => e.preventDefault()}>
              <Checkbox
                checked={disciplinesToDisplay[d] === true}
                onChange={() => dispatch(setDisciplineToDisplayInRedux(d))}
                label={
                  <Group gap={8} wrap="nowrap">
                    <Box
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: 3,
                        background: color,
                        border: "1px solid rgba(0,0,0,0.15)",
                        flex: "0 0 auto",
                      }}
                    />
                    <Group gap={6} wrap="nowrap">
                      <Text size="sm">{label}</Text>
                      {meta?.label && (
                        <Text size="xs" c="dimmed">
                          ({d})
                        </Text>
                      )}
                    </Group>
                  </Group>
                }
              />
            </Box>
          );
        })}

        {uniqDisciplines.length === 0 && (
          <Box px="xs" py="sm">
            <Text size="xs" c="dimmed">
              Ingen disipliner funnet.
            </Text>
          </Box>
        )}
      </Box>
    </>
  );
};
